/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make changes to this file directly.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WordSearchImport } from './routes/word-search'
import { Route as SokobanImport } from './routes/sokoban'
import { Route as NonogramImport } from './routes/nonogram'
import { Route as CrosswordImport } from './routes/crossword'
import { Route as BlockworldImport } from './routes/blockworld'
import { Route as IndexImport } from './routes/index'

// Create Virtual Routes

// Create/Update Routes

const WordSearchRoute = WordSearchImport.update({
  path: '/word-search',
  getParentRoute: () => rootRoute,
} as any)

const SokobanRoute = SokobanImport.update({
  path: '/sokoban',
  getParentRoute: () => rootRoute,
} as any)

const NonogramRoute = NonogramImport.update({
  path: '/nonogram',
  getParentRoute: () => rootRoute,
} as any)

const CrosswordRoute = CrosswordImport.update({
  path: '/crossword',
  getParentRoute: () => rootRoute,
} as any)

const BlockworldRoute = BlockworldImport.update({
  path: '/blockworld',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/blockworld': {
      preLoaderRoute: typeof BlockworldImport
      parentRoute: typeof rootRoute
    }
    '/crossword': {
      preLoaderRoute: typeof CrosswordImport
      parentRoute: typeof rootRoute
    }
    '/nonogram': {
      preLoaderRoute: typeof NonogramImport
      parentRoute: typeof rootRoute
    }
    '/sokoban': {
      preLoaderRoute: typeof SokobanImport
      parentRoute: typeof rootRoute
    }
    '/word-search': {
      preLoaderRoute: typeof WordSearchImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  BlockworldRoute,
  CrosswordRoute,
  NonogramRoute,
  SokobanRoute,
  WordSearchRoute,
])

/* prettier-ignore-end */
